import React, { forwardRef } from 'react'
import styled from 'styled-components'
import { themedBorderRadius } from '../styles'
import { Shimmer } from '../shimmer'

export const PreloaderLine = forwardRef(
	(
		{
			height,
			tag,
			className,
		}: { height?: number; tag?: string; className?: string },
		ref
	) => {
		return (
			<ShimmerWrapper
				ref={ref as React.MutableRefObject<HTMLDivElement>}
				tag={tag}
				height={height}
				className={className}
			>
				<Shimmer />
			</ShimmerWrapper>
		)
	}
)

const ShimmerWrapper = styled.div<{ height?: number; tag?: string }>`
	height: ${p => (p.height ? `${p.height}px` : '100%')};
	overflow: hidden;
	margin-bottom: 0;
	${themedBorderRadius};
`
